export const DEBUG_QS_PARAMETER:string = 'debug'
export const ERROR_QS_PARAMETER:string = 'error'
export const TOKEN_QS_PARAMETER:string = 't'
export const isDebugMode = (searchParams:URLSearchParams) => searchParams.has(DEBUG_QS_PARAMETER)
export const getQueryParameters = (search: string) => new URLSearchParams(search)
